import { createFileRoute } from '@tanstack/react-router'
import OnlyOfficePage from '@/app/documents/OnlyOfficePage'

export const Route = createFileRoute('/_auth/onlyoffice')({
  component: OnlyOfficeRoute,
})

function OnlyOfficeRoute() {
  return <OnlyOfficePage />
}
